import { AppDispatch } from "features";
import { useDispatch } from "react-redux";

// same as useDispatch but correctly typed for the app store
export const useAppDispatch = () => useDispatch<AppDispatch>();
